import React from 'react'
import { css } from '@emotion/css'
import { CellRenderer, CellProps } from '../../../legacy-design-system/grid'
import { VulnerabilityRowActionList } from '../actions/row-action-list'
import { PureQueryOptions } from 'apollo-client'
import { Role } from '@contrast-security-inc/base-types'

const actionContainerCss = css`
  margin-left: auto;
  margin-right: 10px;
`

interface GetRendererProps {
  organizationID: string
  refetchQueries: PureQueryOptions[]
  refresh: () => Promise<any>
  trackJob: (job: {
    id: string
    progress: number
    total: number
  }) => Promise<void>
  restrictedEditRole?: boolean
}
export interface Vulnerability {
  id: string
  title: string
  tags: string[]
  reportedToBugTrackerTime?: string
  application: {
    role: Role
    licensed: boolean
    id: string
    parentApplicationId?: string
  }
}

interface RowData {
  vulnerability?: Vulnerability
}

export function getRowActionsCellRenderer({
  organizationID,
  refresh,
  refetchQueries,
  trackJob,
  restrictedEditRole
}: GetRendererProps): CellRenderer<RowData> {
  return function renderRowActionCell({
    rowData,
    getCellContentProps,
    allSelected,
    selectedCount
  }: CellProps<RowData> & {
    allSelected: boolean
    selectedCount: number
  }) {
    const someSelected = allSelected || !!selectedCount
    if (rowData.vulnerability) {
      const { vulnerability } = rowData

      return (
        !someSelected && (
          <div
            {...getCellContentProps({ className: actionContainerCss })}
            data-testid="vuln-row-action-list"
          >
            <VulnerabilityRowActionList
              trackJob={trackJob}
              vulnerability={vulnerability}
              applicationRole={vulnerability.application.role}
              organizationID={organizationID}
              refresh={refresh}
              refetchQueries={refetchQueries}
              restrictedEditRole={restrictedEditRole}
            />
          </div>
        )
      )
    }
    return null
  }
}
